import React from "react";

import { useState, useEffect } from "react";
import {
  Card,
  Spin,
  Typography,
  Table,
  Progress,
  message,
  Row,
  Col,
  Statistic,
  Space,
  Tag,
} from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  AimOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import Filters from "../filters";
import { useAsync } from "../../../../../utils/use-async";
import { client } from "../../../../../utils/api-client";
import { useAuth } from "../../../../../context/auth-context";
import "./style.css";
import transformGroupedData from "./service";
const { Title, Text } = Typography;

const UserTargetReport = () => {
  const { run, isLoading, data } = useAsync();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [payloadData, setPayloadData] = useState({});
  const [roleData, setRole] = useState("");
  const [summaryStats, setSummaryStats] = useState({
    totalDone: 0,
    totalTarget: 0,
    overallProgress: 0,
    uniqueModerators: 0,
  });

  const { user } = useAuth();
  const allRole = user.roleData.map((e) => ({ label: e, value: e }));

  const submitData = async (val) => {
    setLoading(true);
    const roles = Array.isArray(roleData) ? roleData : [roleData];
    const payload = { ...val, roleData: roles };
    const requestType = "user";

    if (user.roleData.includes("MANAGER")) {
      payload.manager = user._id;
    }
    if (
      !user.roleData.includes("ADMIN") &&
      !user.roleData.includes("MANAGER")
    ) {
      payload.user = user.email;
      payload.fromDate = payloadData.fromDate;
      payload.toDate = payloadData.toDate;
    }

    try {
      const res = await run(
        client("target/user/report", {
          body: { ...payload, type: requestType },
          method: "POST",
        })
      );
      if (res.success && res.message === "Report Generated") {
        message.success(res.message);
        setTableData(
          transformGroupedData(res.data.groupedData, setSummaryStats)
        );
      } else {
        message.error(res.message || "Failed to fetch data");
      }
    } catch (error) {
      console.log(error);
      message.error("Failed to submit data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    run(client("department/all/report"));
  }, []);

  useEffect(() => {
    if (data?.message === "Fetched departments") {
      setDepartments(data.departments);
    }
  }, [data]);

  const setRoleChange = (e) => {
    setRole(e);
  };

  const getProgressColor = (progress) => {
    if (progress >= 100) return "#52c41a";
    if (progress >= 70) return "#1890ff";
    if (progress >= 50) return "#faad14";
    return "#ff4d4f";
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Moderator ID",
      dataIndex: "modId",
      key: "modId",
      render: (text) => {
        const moderators = text.split(", ");
        return (
          <Space size={[0, 4]} wrap>
            {moderators.map((mod, index) => (
              <Tag color="blue" key={index}>
                {mod}
              </Tag>
            ))}
          </Space>
        );
      },
    },
    {
      title: "Sub Project",
      dataIndex: "subProject",
      key: "subProject",
      render: (text) => <Tag color="cyan">{text}</Tag>,
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Done",
      dataIndex: "done",
      key: "done",
      render: (text) => (
        <Text strong style={{ color: "#52c41a" }}>
          {text}
        </Text>
      ),
    },
   
    {
      title: "Qualitative Records",
      dataIndex: "qualitative",
      key: "qualitative",
      render: (text) => <Text strong>{text}</Text>,
    },
  ];

  return (
    <div style={{ padding: "20px", background: "#f5f5f5", minHeight: "100vh" }}>
      <Card
        style={{
          marginBottom: "24px",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
        }}
      >
        <Title level={2} style={{ margin: 0, color: "#1890ff" }}>
          User Target Report
        </Title>
      </Card>

      <Card>
        <Filters
          setRoleChange={setRoleChange}
          departments={departments}
          users={users}
          roleOption={allRole}
          projects={projects}
          submitData={submitData}
          setPayloadData={setPayloadData}
          payloadData={payloadData}
          isLoading={isLoading}
        />
      </Card>
      <Card>
        <Spin spinning={loading || isLoading}>
          {tableData.length > 0 ? (
            <Table
              columns={columns}
              dataSource={tableData}
              rowKey="key"
              pagination={{
                pageSize: 10,
                showTotal: (total) => `Total ${total} records`,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50"],
              }}
              bordered
              scroll={{ x: "max-content" }}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "table-row-light" : "table-row-dark"
              }
            />
          ) : (
            <div>
              <Text type="secondary">
                No data available. Please apply filters and submit to see
                results.
              </Text>
            </div>
          )}
        </Spin>
      </Card>
    </div>
  );
};

export default UserTargetReport;
